import { DeleteOutlined, EditOutlined, CalculatorOutlined } from "@ant-design/icons";
import { Button, Card, Col, Image, Popover, Row, Table, Typography, InputNumber, Space, Spin } from "antd";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteProduct } from "../../redux/actions/product/deleteProductAction";
import { loadSingleProduct, loadSingleRunningSize, calculateRunningRate } from "../../redux/actions/product/detailProductAction";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

const DetailsProd = () => {
	const { id } = useParams();
	let navigate = useNavigate();

	//dispatch
	const dispatch = useDispatch();
	const product = useSelector((state) => state.products.product);

	//Delete Supplier
	const onDelete = () => {
		try {
			dispatch(deleteProduct(id));

			setVisible(false);
			toast.warning(`Product : ${product.name} is removed `);
			return navigate("/product");
		} catch (error) {
			console.log(error.message);
		}
	};
	// Delete Supplier PopUp
	const [visible, setVisible] = useState(false);
	const [rate, setRate] = useState(null);
	const [rateLoading, setRateLoading] = useState(false);
	const [qtyOverride, setQtyOverride] = useState(null);

	const handleVisibleChange = (newVisible) => {
		setVisible(newVisible);
	};

	const handleCalculateRate = async () => {
		setRateLoading(true);
		setRate(null);
		try {
			const overrides = {};
			if (qtyOverride) overrides.quantity = qtyOverride;
			const resp = await dispatch(calculateRunningRate(id, overrides));
			if (resp.message === "success") {
				setRate(resp.data);
				toast.success("Rate calculated");
			} else {
				toast.error(resp.error || "Rate calculation failed");
				if (resp.data) setRate(resp.data);
			}
		} catch (err) {
			toast.error(err.message || "Rate calculation failed");
		}
		setRateLoading(false);
	};

	useEffect(() => {
		dispatch(loadSingleRunningSize(id));
	}, [id]);

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}
	return (
		<div>
			<PageTitle title=' Back  ' />

			<div className='mr-top'>
				{product ? (
					<Fragment key={product.id}>
						<Card bordered={false} className='card-custom'>
							<div className='card-header d-flex justify-content-between m-3'>
								<h5>
									<i className='bi bi-person-lines-fill'></i>
									<span className='mr-left'>
										ID : {product.id} | {product.name} 
									</span>
								</h5>
								<div className='text-end'>
									<Button
										className='m-2'
										type='primary'
										shape='round'
										icon={<CalculatorOutlined />}
										loading={rateLoading}
										onClick={handleCalculateRate}>
										Calculate Rate
									</Button>
									<Link
										className='m-2'
										to={`/running-size/${product.id}/update`}
										state={{ data: product }}>
										<Button
											type='primary'
											shape='round'
											icon={<EditOutlined />}></Button>
									</Link>
									<Popover
										className='m-2'
										content={
											<a onClick={onDelete}>
												<Button type='primary' danger>
													Yes Please !
												</Button>
											</a>
										}
										title='Are you sure you want to delete ?'
										trigger='click'
										visible={visible}
										onVisibleChange={handleVisibleChange}>
										<Button
											type='danger'
											shape='round'
											icon={<DeleteOutlined />}></Button>
									</Popover>
								</div>
							</div>
							<Row className='d-flex justify-content-between'>
								<Col xs={24} lg={12}>
									<div className='card-body ms-2'>
										<h5> Running Size Information :</h5>
										<p>
											<Typography.Text strong>Customer Name:</Typography.Text>{" "}
											{product.customer?.name}
										</p>
										<p>
											<Typography.Text strong>Sub Category :</Typography.Text>{" "}
											{product.product_sub_category?.name}
										</p>
										<p>
											<Typography.Text strong>Length :</Typography.Text>{" "}
											{product.length}
										</p>
										<p>
											<Typography.Text strong>Width :</Typography.Text>{" "}
											{product.width}
										</p>
										<p>
											<Typography.Text strong>Height :</Typography.Text>{" "}
											{product.height}
										</p>
										<p>
											<Typography.Text strong>Unit :</Typography.Text>{" "}
											{product.unit_type}
										</p>
										
										<p>
											<Typography.Text strong>Casting Type :</Typography.Text>{" "}
											{product.casting_type}
										</p>

										<p>
											<Typography.Text strong>Last Sale Price :</Typography.Text>{" "}
											{product.last_sale_price}
										</p>

										<p>
											<Typography.Text strong>Avg. Order Qty :</Typography.Text>{" "}
											{product.avg_order_quantity}
										</p>
										<p>
											<Typography.Text strong>Top Conversion Rate /Kg :</Typography.Text>{" "}
											{product.top_conversion_rate || 'N/A'}
										</p>
										<p>
											<Typography.Text strong>Box Conversion Rate /Kg :</Typography.Text>{" "}
											{product.box_conversion_rate || 'N/A'}
										</p>
										<p>
											<Typography.Text strong>RS :</Typography.Text>{" "}
											{product.rs || 'N/A'}
										</p>
										<p>
											<Typography.Text strong>CS :</Typography.Text>{" "}
											{product.cs || 'N/A'}
										</p>
										<p>
											<Typography.Text strong>Boxes per Sheet (m) :</Typography.Text>{" "}
											{product.boxes_per_sheet || 'N/A'}
										</p>
										<p>
											<Typography.Text strong>Sheets per Box (n) :</Typography.Text>{" "}
											{product.sheets_per_box || 'N/A'}
										</p>
										<p>
											<Typography.Text strong>Box Type :</Typography.Text>{" "}
											{product.box_type ? product.box_type.charAt(0).toUpperCase() + product.box_type.slice(1) : 'N/A'}
										</p>
										<p>
											<Typography.Text strong>Rate Type :</Typography.Text>{" "}
											{product.rate_type ? product.rate_type.charAt(0).toUpperCase() + product.rate_type.slice(1) : 'N/A'}
										</p>
										{product.rate_type && product.rate_type !== 'individual' && (
											<p>
												<Typography.Text strong>No. of Inners :</Typography.Text>{" "}
												{product.packing_quantity || 'N/A'}
											</p>
										)}
										<p>
											<Typography.Text strong>Glueing :</Typography.Text>{" "}
											{product.joining_method === 'stitching' ? 'Stitching' : product.joining_method === 'hand_pasting' ? 'Hand Pasting' : 'N/A'}
										</p>
										<p>
											<Typography.Text strong>Remarks :</Typography.Text>{" "}
											{product.remarks || 'N/A'}
										</p>
									</div>
								</Col>

								<Col xs={24} lg={12}>
									<div className='card-body ms-2'>
										<h5> Customization Information :</h5>
										<p>
											<Typography.Text strong>Ply :</Typography.Text>{" "}
											{product.ply}
										</p>
										<p>
											<Typography.Text strong>Layers :</Typography.Text>{" "}
											{JSON.parse(product.layers).map(layer => (
												<div>Id: {layer.layerId} | Layer: {layer.layerType} | Material: {layer.materialType} | Gsm: {layer.gsm} | Bf: {layer.bf} | Ff: {layer.ff || ''}</div>
											) 
											)}
										</p>
										<p>
											<Typography.Text strong>Printing :</Typography.Text>{" "}
											{product.is_printing ? (<div> Type: {JSON.parse(product.printing)?.printingType } | Colors: {JSON.parse(product.printing)?.printingColors } | Sides: {JSON.parse(product.printing)?.printingSides } </div>): 'No'}
										</p>
										<p>
											<Typography.Text strong>Coating :</Typography.Text>{" "}
											{/* <div>{JSON.parse(product.coating).coatings.map(i => <span>{i} ,</span>) }</div> */}
											
											{product.is_coating ? (<div>{JSON.parse(product.coating).coatings.map(i => <span>{i} ,</span>) }</div>): 'No'}
										</p>
										
									</div>
								</Col>

								<Col xs={24} lg={12}>
									<div className='card-body ms-3'>
										<Image
											width={300}
											className='fluid'
											src={product.thumbnail_image_url}
										/>
									</div>
								</Col>
							</Row>
						</Card>

						{/* ── Rate Calculation Section ─────────────────────── */}
						{rateLoading && (
							<Card bordered={false} className='card-custom' style={{ marginTop: 16, textAlign: 'center', padding: 40 }}>
								<Spin size="large" tip="Calculating rate..." />
							</Card>
						)}

						{rate && !rateLoading && (
							<Card bordered={false} className='card-custom' style={{ marginTop: 16 }}>
								<Row className='d-flex justify-content-between'>
									<Col xs={24} lg={24}>
										<div className='card-body ms-2'>
											<h5>Rate Calculation :</h5>
											<Row gutter={16}>
												<Col xs={24} md={8}>
													<p><Typography.Text strong>Net Rate:</Typography.Text>{" "}₹{rate?.finalRate?.toFixed(2) || 0}</p>
													<p><Typography.Text strong>Sheet Size (RS × CS):</Typography.Text>{" "}{rate?.RS} × {rate?.CS}</p>
													<p><Typography.Text strong>No of Sheets (N):</Typography.Text>{" "}{rate?.N}</p>
													<p><Typography.Text strong>Boxes per Sheet (M):</Typography.Text>{" "}{rate?.M}</p>
												</Col>
												<Col xs={24} md={8}>
													<p><Typography.Text strong>Net GSM:</Typography.Text>{" "}{rate?.NET_GSM}</p>
													<p><Typography.Text strong>Box Weight (Kgs):</Typography.Text>{" "}{rate?.boxWeight?.toFixed(3) || 0}</p>
													<p><Typography.Text strong>Net Fixed Cost:</Typography.Text>{" "}₹{rate?.netFixedCost || 0}</p>
													<p><Typography.Text strong>Quantity:</Typography.Text>{" "}{rate?.quantity}</p>
												</Col>
												<Col xs={24} md={8}>
													<Space style={{ marginBottom: 12 }}>
														<Typography.Text strong>Recalculate with Qty:</Typography.Text>
														<InputNumber
															min={1}
															placeholder="Override qty"
															value={qtyOverride}
															onChange={setQtyOverride}
															style={{ width: 120 }}
														/>
														<Button
															type="primary"
															size="small"
															loading={rateLoading}
															onClick={handleCalculateRate}>
															Recalculate
														</Button>
													</Space>
												</Col>
											</Row>

											<h5 style={{ marginTop: 8 }}>Detailed Rate Breakup :</h5>
											{(() => {
												const topRate = rate?.topRate || 0;
												const restRate = rate?.restRate || 0;
												const printRate = rate?.printRate || 0;
												const fixedCost = rate?.fixedCostPerBox || 0;
												const laminationRate = rate?.laminationRate || 0;
												const leafingRate = rate?.leafingRate || 0;
												const spotUvRate = rate?.spotUvRate || 0;

												const rateData = [
													{ key: 1, parameter: "Top Layer Rate", value: topRate, total: topRate },
													{ key: 2, parameter: "Rest Layers Rate", value: restRate, total: topRate + restRate },
													{ key: 3, parameter: "Printing Cost", value: printRate, total: topRate + restRate + printRate },
													{ key: 4, parameter: "Fixed Cost", value: fixedCost, total: topRate + restRate + printRate + fixedCost },
													{ key: 5, parameter: "Lamination Rate", value: laminationRate, total: topRate + restRate + printRate + fixedCost + laminationRate },
													{ key: 6, parameter: "Leafing Rate", value: leafingRate, total: topRate + restRate + printRate + fixedCost + laminationRate + leafingRate },
													{ key: 7, parameter: "Spot UV Rate", value: spotUvRate, total: topRate + restRate + printRate + fixedCost + laminationRate + leafingRate + spotUvRate },
													{ key: 8, parameter: "Net Rate", value: rate?.finalRate || 0, total: rate?.finalRate || 0 },
												];

												const columns = [
													{ title: 'Rate Components', dataIndex: 'parameter', key: 'parameter', width: '40%' },
													{ title: 'Piecewise Rate', dataIndex: 'value', key: 'value', width: '30%', render: (v) => `₹${v.toFixed(2)}` },
													{ title: 'Total Rate', dataIndex: 'total', key: 'total', width: '30%', align: 'right', render: (t) => `₹${t.toFixed(2)}` },
												];

												return (
													<Table
														dataSource={rateData}
														columns={columns}
														pagination={false}
														size="small"
														bordered
													/>
												);
											})()}
										</div>
									</Col>
								</Row>
							</Card>
						)}
					</Fragment>
				) : (
					<Loader />
				)}
			</div>
		</div>
	);
};

export default DetailsProd;


// {
//     "id": "6794eab07586f8ebd79ab20a",
//     "name": "Al samah",
//     "product_sub_category_id": "67447e398fb92e8099437775",
//     "customer_id": "674ad782cec441a0df2a7163",
//     "length": 13.5,
//     "width": 14.3,
//     "height": 23,
//     "avg_order_quantity": 234,
//     "unit_type": "inches",
//     "last_sale_price": 12,
//     "thumbnail_image": null,
//     "casting_type": "Rotary-Slot",
//     "active": true,
//     "ply": 5,
//     "layer_selector": false,
//     "is_printing": false,
//     "is_coating": false,
//     "layers": "[{\"layerId\":1,\"layerType\":\"top\",\"materialType\":\"kraft\",\"gsm\":230,\"bf\":22,\"ff\":\"\"},{\"layerId\":2,\"layerType\":\"flute\",\"materialType\":\"semi\",\"gsm\":140,\"bf\":20,\"ff\":1.5},{\"layerId\":3,\"layerType\":\"face\",\"materialType\":\"kraft\",\"gsm\":180,\"bf\":22,\"ff\":\"\"},{\"layerId\":4,\"layerType\":\"flute\",\"materialType\":\"semi\",\"gsm\":140,\"bf\":20,\"ff\":1.5},{\"layerId\":5,\"layerType\":\"bottom\",\"materialType\":\"kraft\",\"gsm\":180,\"bf\":22,\"ff\":\"\"}]",
//     "printing": "{}",
//     "coating": "{\"coatings\":[]}",
//     "createdAt": "2025-01-25T13:44:15.673Z",
//     "updatedAt": "2025-01-25T13:44:15.673Z",
//     "product_sub_category": {
//         "name": "Regular Folding Cartons"
//     },
//     "customer": {
//         "name": "PRESSWELL STEELS PRIVATE LIMITED"
//     }
// }